export const collaboratorsLocale = {
   title: '協力者',
   code: "紹介コード",
   link: "リンク",
   number_people_invited: "招待されたユーザー数",
   level: "レベル",
   balance_received: "受け取られていない残高",
   register_withdraw: "撤回登録",
   list_user_invite: 'ユーザー招待リスト',
   search: '検索',
   stt: 'STT',
   time: '時間',
   mail: 'メール',
   kyc: 'kyc',
   withdrawal_history: '撤回履歴',
   amount: '数量',
   token_type: 'トーケンタイプ',
   status: 'スターテス',
   register_title: '協力者になるために登録します',
   register_content: '以下の確認ボタンをクリックすると、AIS 協力者プログラムに参加することに同意したものとみなされます。',
   confirm_register: '確認',
   close_register: 'キャンセル',
   withdraw_all: 'すべてに撤回',
   withdraw_landmark: 'ランドマークに撤回',
   money: '金額',
   money_remaining: '残り',
   withdrawal_fee: '撤回手数料',
   bonus_draw_milestone: 'ボーナス出金マイルストーン (紹介者) ',
   withdraw_content: 'ユーザーは、現在のレベルまたは獲得した全額に基づいてお金を引き出すことを選択できます。撤回するとレベルと紹介数はリセットされます。 すべてに撤回には 2000 STN-A の手数料がかかります。',
   unknown_error: 'エラーが発生しました。後でもう一度お試しください。',
   oops: '申し訳ありません！',
   ok: 'OKです',
};
